import React, {useEffect} from "react";

import useInfoModal from "@components/Extras/hooks/useInfoModal";
import {ConfirmationModal, Modal} from "@components/modals";

interface DateChangeModalProps {
  isDateAdjusted: boolean;
}

export default function DateChangeModal({
  isDateAdjusted,
}: DateChangeModalProps): JSX.Element {
  const {openInfoModal, closeInfoModal, infoModalProps} = useInfoModal();
  const modalConfig = {
    title: "Menu date changed",
    confirmationContent: (
      <>
        Please note: the date you had selected is not available for this
        location. We’ve updated you to the first available menu date.
      </>
    ),
    confirmButtonText: "OK",
    cancelButtonText: "",
  };

  useEffect(() => {
    if (isDateAdjusted) {
      openInfoModal(modalConfig);
    }
  }, [isDateAdjusted]);

  return (
    <Modal
      {...infoModalProps}
      modalComponent={ConfirmationModal}
      onClose={closeInfoModal}
    />
  );
}
